import authenticatedPopsApi from "../utils/portalApi";

export const postLoanForm = async (endpoint, loanForm) =>
  authenticatedPopsApi.post(endpoint, loanForm);